import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { LayerDTO, WellLayerDTO } from 'business/models/Models';
import EVolumetricLayerDispense from './EVolumetricLayerDispense';
import EVolumetricLayerType from './EVolumetricLayerType';
import { getLayer } from './GenerateCommon';
import { VolumetricLayerKey } from './VolumetricLayerKey';
import { VolumetricWellLayer } from './VolumetricWellLayer';
import { WellIng, WellLayer } from 'components/Experiment/constants';

export class VolumetricWellLayers {
  private layers: Map<VolumetricLayerKey, VolumetricWellLayer> = new Map<
    VolumetricLayerKey,
    VolumetricWellLayer
  >();
  WellRow: WellIng;
  docData: ExperimentDtoClient;
  constructor(docData: ExperimentDtoClient, wellRow: WellIng) {
    this.docData = docData;
    this.WellRow = wellRow;
    const manualConcentration: Array<WellLayer> = [];
    const robotConcentration: Array<WellLayer> = [];
    for (const wellLayer of wellRow.wellLayerList) {
      const layer = getLayer(docData, wellLayer.layerId);
      if (layer.volumeBasedAddition) {
        this.AddVolumetricLayer(wellLayer, layer);
      } else if (layer.dispenseManually) {
        manualConcentration.push(wellLayer);
      } else {
        robotConcentration.push(wellLayer);
      }
    }
    this.AddConcentrationLayers(EVolumetricLayerDispense.Manual, manualConcentration);
    this.AddConcentrationLayers(EVolumetricLayerDispense.Robot, robotConcentration);
  }

  AddVolumetricLayer(wellLayerRow: WellLayer, layer: LayerDTO) {
    const dispense = layer.dispenseManually
      ? EVolumetricLayerDispense.Manual
      : EVolumetricLayerDispense.Robot;
    const type = EVolumetricLayerType.Volumetric;
    const wellLayerRows: Array<WellLayer> = [];
    wellLayerRows.push(wellLayerRow);
    const layer1: VolumetricWellLayer = new VolumetricWellLayer(
      this.docData,
      this,
      dispense,
      type,
      wellLayerRows,
    );
    this.layers.set(layer1.Key, layer1);
  }
  private AddConcentrationLayers(
    dispense: EVolumetricLayerDispense,
    wellLayerRows: WellLayer[],
  ) {
    if (wellLayerRows.length == 0) {
      return;
    }
    const type: EVolumetricLayerType = EVolumetricLayerType.Concentration;
    const layer = new VolumetricWellLayer(
      this.docData,
      this,
      dispense,
      type,
      wellLayerRows,
    );
    this.layers.set(layer.Key, layer);
  }
  get WellID(): number {
    return this.WellRow.wellId;
  }
  public GetLayer(key: VolumetricLayerKey): VolumetricWellLayer {
    if (!this.layers.has(key)) {
      return null;
    }
    return this.layers.get(key);
  }
  public ContainsLayer(key: VolumetricLayerKey): boolean {
    return this.layers.has(key);
  }
  public AddLayer(key: VolumetricLayerKey) {
    const wellLayerRows = [];

    for (const layerID of key.LayerIDs) {
      const layerRow: LayerDTO = this.docData.layers.find((layer) => layer.id == layerID);
      if (layerRow == null) {
        layerRow.id = layerID;
        layerRow.volumeBasedAddition = key.Type == EVolumetricLayerType.Volumetric;
        layerRow.dispenseManually = key.Dispense == EVolumetricLayerDispense.Manual;
        layerRow.overrideLayer = false;
        layerRow.locked = false;
        this.docData.layers = [...this.docData.layers, layerRow];
      }
      const wellLayerRow: WellLayerDTO = new WellLayerDTO();
      wellLayerRow.wellId = this.WellRow.wellId;
      wellLayerRow.layerId = layerRow.id;
      wellLayerRow.volume = 0;
      wellLayerRow.waterVolume = 0;
      wellLayerRows.push(wellLayerRow);
    }
    const layer: VolumetricWellLayer = new VolumetricWellLayer(
      this.docData,
      this,
      key.Dispense,
      key.Type,
      wellLayerRows,
    );
    this.layers.set(layer.Key, layer);
  }
  public IsSingleLayer(): boolean {
    return this.layers.size == 1;
  }
  public get SingleLayer(): VolumetricWellLayer {
    return this.GetLayerByIndex(0);
  }
  public GetLayerByIndex(index: number): VolumetricWellLayer {
    return this.layers[this.layers.keys[index]];
  }
  public get Count(): number {
    return this.layers.size;
  }

  public get _layers() {
    return this.layers;
  }
  private get RobotLayers() {
    const robotLayers: VolumetricWellLayers = new VolumetricWellLayers(
      this.docData,
      this.WellRow,
    );
    const manualKeys: VolumetricLayerKey[] = [];
    for (const key of robotLayers.layers.keys()) {
      if (key.Dispense == EVolumetricLayerDispense.Manual) {
        manualKeys.push(key);
      }
    }
    for (const key of manualKeys) {
      robotLayers.layers.delete(key);
    }
    return robotLayers;
  }
  public static GetWellLayers(
    docData: ExperimentDtoClient,
    wellRow: WellIng
  ): VolumetricWellLayers {
    return new VolumetricWellLayers(docData, wellRow);
  }
  public static GetRobotLayers(docData: ExperimentDtoClient, wellRow) {
    return new VolumetricWellLayers(docData, wellRow).RobotLayers;
  }
}
